import React, { useState, useEffect } from "react"
import {Shield, User} from 'lucide-react'
import { lumi } from "../lib/lumi"

interface AdminPanelProps {
  onOpenAdminPage: () => void
}

export function AdminPanel({ onOpenAdminPage }: AdminPanelProps) {
  const [user, setUser] = useState(lumi.auth.user)

  useEffect(() => {
    const unsubscribe = lumi.auth.onAuthChange(({ user }) => {
      setUser(user)
    })
    return unsubscribe
  }, [])

  if (!user) {
    return (
      <button
        onClick={() => lumi.auth.signIn()}
        className="flex items-center gap-2 text-gray-700 hover:text-teal-600 transition-colors font-medium"
      >
        <User className="w-5 h-5" />
        <span className="hidden md:inline">Connexion</span>
      </button>
    )
  }

  return (
    <button
      onClick={onOpenAdminPage}
      className="flex items-center gap-2 px-3 py-2 rounded-full text-gray-700 hover:text-teal-600 hover:bg-teal-50 transition-all font-medium border-2 border-transparent hover:border-teal-200"
    >
      <div className="w-8 h-8 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center shadow-md">
        {user.userRole === "ADMIN" ? (
          <Shield className="w-5 h-5 text-white" />
        ) : (
          <User className="w-5 h-5 text-white" />
        )}
      </div>
      <span className="hidden md:inline font-semibold">{user.userName}</span>
    </button>
  )
}
